import styled from "styled-components"
import { Container, PageForm } from "client/components"

const stateColumnWidth = "280px"
const stateColumnMargin = "15px"

export const HighPriorityWrapper = styled.div<{
    active: boolean
}>`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 26px;
    color: ${(props) => (props.active ? props.theme.highPriorityActiveColor : props.theme.highPriorityInactiveColor)};

    & > div {
        position: absolute;
        right: 2px;
    }
`
export const TaskLayout = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background: ${(props) => props.theme.pageLayoutBackground};
`
export const TaskBodyColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - ${stateColumnWidth} - ${stateColumnMargin});
`
export const TaskForm = styled(PageForm)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const TaskCommentListWrapper = styled(Container)`
    background: ${(props) => props.theme.pageContentBackground};
`
export const TaskStateColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: ${stateColumnWidth};
    margin-left: ${stateColumnMargin};
`
export const TaskStateHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    height: 50px;
    width: 100%;
    padding: 8px 15px;
    background: ${(props) => props.theme.taskStateHeaderBackground};
    font-size: 13px;
    font-family: ${(props) => props.theme.openSans};

    & > span {
        color: ${(props) => props.theme.taskStateHeaderColor};
    }
`
export const TaskStatus = styled.span`
    font-weight: 600;
    margin-right: 5px;
`
export const TaskStatusSince = styled.span`
    margin-right: 5px;
`
export const TaskStateBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const TaskOverdueWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 15px;
    margin-bottom: 3px;
    font-size: 13px;
    font-weight: 600;
    font-family: ${(props) => props.theme.openSans};
    background: ${(props) => props.theme.taskOverdueBackground};
    color: ${(props) => props.theme.taskOverdueColor};

    & > i {
        margin-right: 5px;
    }
`
export const PopupSpan = styled.span`
    display: flex;

    & > i {
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: left;
    }
`
export const UserRow = styled.div`
    display: flex;
    align-items: center;

    & > div:last-child {
        margin-left: 5px;
    }
`
